// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Typography Styles */
.loyalty-text-main-header {
  font-size: 1.4rem;
  font-weight: 600;
  color: #20455e;
  line-height: 2;
}

.dark .loyalty-text-main-header,
.dark .available-wrapper-box,
.dark .available-wrapper-box-I {
  color: #fff !important;
}

.colored-text {
  color: #0562fb;
  margin-top: 0.1rem;
}

.points-text-loyalty {
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.5;
}

.loyalty-small-wrapper-txt {
  font-size: 1.2rem;
  font-weight: 400;
}

/* Input Styles */
.otp-validation-input {
  width: 100%;
  border: 1px solid lightgray;
  border-radius: 7px;
  padding: 8px;
  margin-top: 1rem;
  outline: none;
}

.otp-validation-input:focus {
  border-color: #0562fb;
}

/* Button Styles */
.redeem-wrapper-btn-I {
  border: none;
  width: 100%;
  background-color: #2954a5;
  color: #fff;
  font-weight: 600;
  margin-top: 2rem;
  border-radius: 5px;
  padding: 10px;
  text-transform: uppercase;
  cursor: pointer;
}

/* Reset Button Styles */
.reset-otp-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.reset-otp-btn {
  margin-top: 1rem;
  margin-right: 0.1rem;
  border: none;
  color: #0562fb;
  background-color: transparent;
  text-transform: capitalize;
  font-size: 1rem;
  cursor: pointer;
  outline: none;
}

.reset-otp-btn:hover {
  text-decoration: underline;
}

.circle-bg-image-9 {
  width: 230px;
  height: 550px;
  border-radius: 50%;
  position: absolute;
  background-color: #6492dd;
  overflow: hidden;
  aspect-ratio: 1/1;
  left: -172px;
  top: 22%;
  z-index: 2;
  opacity: 0.3;
}

.circle-bg-image-10 {
  width: 900px;
  height: 900px;
  border-radius: 50%;
  position: absolute;
  background: linear-gradient(#6492dd, #d4eafc, #cde7fc, #d4eafc);
  left: -450px;
  top: 85%;
  overflow: hidden;
  z-index: -1;
  opacity: 0.4;
}

.button-wrapper-center-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
}

.dark .no-loyalty-wrapper-box {
  background-color: #353a50 !important;
  color: white !important;
}

.light .no-loyalty-wrapper-box {
  background-color: white !important;
  color: #353a50 !important;
}

.loyalty-content-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  z-index: 99;
  position: relative;
}

.close-loyalty-modal {
  position: absolute !important;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
  color: #0562fb;
  font-size: 1.5rem !important;
  font-weight: 600;
  z-index: 3;
}

@media (min-width: 568px) {
  .close-loyalty-modal {
    display: none !important;
  }
}

.enter-otp-loyalty {
  color: black !important;
  font-size: 0.9rem !important;
  font-weight: bold !important;
}

.dark .enter-otp-loyalty {
  color: white !important;
}

.loyalty-custom-input {
  border-radius: 4px;
  width: 75px !important;
  margin-bottom: 10px !important;
}

.loyalty-custom-input .MuiInputBase-input {
  text-align: right !important;
}

.loyalty-text-blacklist {
  font: 1.1rem !important;
  font-weight: bold !important;
  text-align: center;
  margin: 3rem 0rem !important;
  color: #0562fb !important;
}

.custom-font-loyalty {
  font-size: 14px !important;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/loyaltySectionModal/index.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,QAAQ;EACR,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,+DAA+D;EAC/D,YAAY;EACZ,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,WAAW;EACX,eAAe;EACf,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* Typography Styles */\n.loyalty-text-main-header {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #20455e;\n  line-height: 2;\n}\n\n.dark .loyalty-text-main-header,\n.dark .available-wrapper-box,\n.dark .available-wrapper-box-I {\n  color: #fff !important;\n}\n\n.colored-text {\n  color: #0562fb;\n  margin-top: 0.1rem;\n}\n\n.points-text-loyalty {\n  font-size: 1.2rem;\n  font-weight: 400;\n  line-height: 1.5;\n}\n\n.loyalty-small-wrapper-txt {\n  font-size: 1.2rem;\n  font-weight: 400;\n}\n\n/* Input Styles */\n.otp-validation-input {\n  width: 100%;\n  border: 1px solid lightgray;\n  border-radius: 7px;\n  padding: 8px;\n  margin-top: 1rem;\n  outline: none;\n}\n\n.otp-validation-input:focus {\n  border-color: #0562fb;\n}\n\n/* Button Styles */\n.redeem-wrapper-btn-I {\n  border: none;\n  width: 100%;\n  background-color: #2954a5;\n  color: #fff;\n  font-weight: 600;\n  margin-top: 2rem;\n  border-radius: 5px;\n  padding: 10px;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n/* Reset Button Styles */\n.reset-otp-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.reset-otp-btn {\n  margin-top: 1rem;\n  margin-right: 0.1rem;\n  border: none;\n  color: #0562fb;\n  background-color: transparent;\n  text-transform: capitalize;\n  font-size: 1rem;\n  cursor: pointer;\n  outline: none;\n}\n\n.reset-otp-btn:hover {\n  text-decoration: underline;\n}\n\n.circle-bg-image-9 {\n  width: 230px;\n  height: 550px;\n  border-radius: 50%;\n  position: absolute;\n  background-color: #6492dd;\n  overflow: hidden;\n  aspect-ratio: 1/1;\n  left: -172px;\n  top: 22%;\n  z-index: 2;\n  opacity: 0.3;\n}\n\n.circle-bg-image-10 {\n  width: 900px;\n  height: 900px;\n  border-radius: 50%;\n  position: absolute;\n  background: linear-gradient(#6492dd, #d4eafc, #cde7fc, #d4eafc);\n  left: -450px;\n  top: 85%;\n  overflow: hidden;\n  z-index: -1;\n  opacity: 0.4;\n}\n\n.button-wrapper-center-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 1rem;\n}\n\n.dark .no-loyalty-wrapper-box {\n  background-color: #353a50 !important;\n  color: white !important;\n}\n\n.light .no-loyalty-wrapper-box {\n  background-color: white !important;\n  color: #353a50 !important;\n}\n\n.loyalty-content-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  z-index: 99;\n  position: relative;\n}\n\n.close-loyalty-modal {\n  position: absolute !important;\n  top: 1rem;\n  right: 1rem;\n  cursor: pointer;\n  color: #0562fb;\n  font-size: 1.5rem !important;\n  font-weight: 600;\n  z-index: 3;\n}\n\n@media (min-width: 568px) {\n  .close-loyalty-modal {\n    display: none !important;\n  }\n}\n\n.enter-otp-loyalty {\n  color: black !important;\n  font-size: 0.9rem !important;\n  font-weight: bold !important;\n}\n\n.dark .enter-otp-loyalty {\n  color: white !important;\n}\n\n.loyalty-custom-input {\n  border-radius: 4px;\n  width: 75px !important;\n  margin-bottom: 10px !important;\n}\n\n.loyalty-custom-input .MuiInputBase-input {\n  text-align: right !important;\n}\n\n.loyalty-text-blacklist {\n  font: 1.1rem !important;\n  font-weight: bold !important;\n  text-align: center;\n  margin: 3rem 0rem !important;\n  color: #0562fb !important;\n}\n\n.custom-font-loyalty {\n  font-size: 14px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
